import { Onix } from './Onix';

export class Contributor {
  ruolo: Onix;

  codice: string;
  nomecompleto: string;
  // prefisso: string; ***** deprecato *****
  cognome: string;
  nome: string;
  // carica: string; ***** deprecato *****
  // pseudonimo: string; ***** deprecato *****

  bio: string;

  boh: boolean; //gestione delirante x abbreviato e portale

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/Contributor.ts